import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";

const CreateOperator = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    // select dropdown
    const [user, setUser] = useState([]);
    const [department, setDepartment] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useCreate } = useAPIQuery({
        key: "operator",
        endpoint: "/api/operator/",
    });

    const handleCreateOperator = (data) => {
        Swal.fire({
            title: "Operator Created!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorOperator = (data) => {
        Swal.fire({
            title: "Error Creating Operator",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateOperator,
        onError: handleErrorOperator,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm();

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var operator = {
            first_name: data?.first_name?.trim(),
            last_name: data?.last_name?.trim(),
            email: data?.email?.trim(),
            mobile_no: data?.phone_number?.trim(),
            department: data?.department.value,
            created_by: userID,
            updated_by: userID,
        };

        mutate({
            data: operator,
        });
    };

    useEffect(() => {
        if (data) {
            setUser(data.user);
            setDepartment(
                data?.department?.map((dept) => ({
                    value: dept?.department_name,
                    label: dept?.department_name,
                }))
            );
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">Create Operator</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        First Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter first name"
                                        id="text-forms-first_name"
                                        {...register("first_name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.first_name && (
                                        <span className="fs-8 text-danger">
                                            First Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Last Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter last name"
                                        id="text-forms-last_name"
                                        {...register("last_name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.last_name && (
                                        <span className="fs-8 text-danger">
                                            Last Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Email Address
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter email address"
                                        id="email-forms-email"
                                        {...register("email", {
                                            required: false,
                                        })}
                                    />
                                    {errors.email && (
                                        <span className="fs-8 text-danger">
                                            Email Address is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label"
                                            htmlFor="input-tel-optional_phone_field"
                                        >
                                            Phone Number
                                        </label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="tel"
                                                className="form-control"
                                                placeholder="Enter phone number"
                                                {...register("phone_number", {
                                                    validate: (value) => {
                                                        if (!value) return true;
                                                        const phoneRegex =
                                                            /^\+?[1-9]\d{6,14}$/;
                                                        return (
                                                            phoneRegex.test(
                                                                value
                                                            ) ||
                                                            "Invalid phone number format"
                                                        );
                                                    },
                                                })}
                                            />
                                            {errors?.phone_number && (
                                                <small className="text-danger mt-1">
                                                    {
                                                        errors?.phone_number
                                                            ?.message
                                                    }
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Department{" "}
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={department ?? []}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-department"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="department"
                                        control={control}
                                    />
                                    {errors.department && (
                                        <span className="fs-8 text-danger">
                                            Department name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-operator-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-operator"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateOperator;
